(function(){

    /*
    * Inizializzazione Swiper.js
    * */
    var swiper = new Swiper(".insightsSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });

    var swiper = new Swiper(".caseSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "767": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
        },
    });

})();
